import { flagFactory } from '../icon';
import Svg from './be.svg';

export default flagFactory(Svg);
